/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';
import genericReducers from '../genericReducer';
import { IReducers } from '../index';

import { GET_SPORT_REWARD_KINDS } from '../../actions/employees';
import { REQUEST, FAILURE, SUCCESS } from '../../actions/utils';

import { ICommonResponse, ISportReward } from '../../api/types';

export type SportRewardKindsState = ICommonResponse<ISportReward>;

const initialState: SportRewardKindsState = {
  content: [],
  loading: false,
};
const generic = genericReducers<SportRewardKindsState>();
const sportRewardKinds: IReducers<SportRewardKindsState> = {
  [GET_SPORT_REWARD_KINDS[REQUEST]]: generic.get.request,
  [GET_SPORT_REWARD_KINDS[SUCCESS]]: generic.get.success,
  [GET_SPORT_REWARD_KINDS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, sportRewardKinds);
